module.exports = "pegasus/assets/tech/email1-img10.png";